import axios from 'axios';

export default function getEmailTypeFilter() {
  return new Promise((resolve, reject) => axios
    .get('/notification/system-admin/api/v1/emailLogEmailTypeFilter')
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
